import axios from './axiosCustom'

const HOST = process.env.REACT_APP_RPG_IR_API

const headers = (apiKey) => ({
  'x-api-key': apiKey,
  'Content-type': 'application/json',
})

export async function postFiles(apiKey, userId, filesType, files) {
  const data = {
    user_id: userId,
    files_type: filesType,
    files: files,
  }

  const res = await axios({
    method: 'POST',
    url: `${HOST}/v1/ocr`,
    headers: headers(apiKey),
    data: data,
  })

  return res
}

export async function getFilesResponse(apiKey, userId, token) {
  let queryString = `&user_id=${userId}`
  queryString += `&token=${token}`

  const res = await axios({
    method: 'GET',
    url: `${HOST}/v1/ocr/result?${queryString}`,
    headers: headers(apiKey),
  })

  return res
}

export async function postGenerateCsv(apiKey, userId, filesType, content) {
  const data = {
    user_id: userId,
    files_type: filesType,
    ...content,
  }

  const res = await axios({
    method: 'POST',
    url: `${HOST}/v1/ocr/export/csv`,
    headers: headers(apiKey),
    data: data,
  })

  return res
}
